export const importSummaryArray = [
    { label: 'Nombre de lignes traitées', value: 0, type: 'OK', key: 'nbLignesTreated' },
    { label: 'Nombre de lignes ignorées', value: 0, type: 'OK', key: 'nbLignesIgnore' },
    { label: 'Nombre de lignes valides', value: 0, type: 'OK', key: 'nbLignesOk' },
    { label: 'Nombre de lignes avec alerte', value: 0, type: 'WARN', key: 'nbLignesWarn' },
    { label: 'Nombre de lignes en erreur', value: 0, type: 'ERROR', key: 'nbLignesError' },
];
